import { NumberInput, coerceNumberProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'se-contextmenu',
    templateUrl: './se-contextmenu.component.html',
    styleUrls: ['./se-contextmenu.component.css'],
    standalone: false
})
export class SeContextMenuComponent {
    // Data Members

    _x?: number;
    @Input()
    get x() { return this._x; }
    set x(value: NumberInput) { this._x = coerceNumberProperty(value); }

    _y?: number;
    @Input()
    get y() { return this._y; }
    set y(value: NumberInput) { this._y = coerceNumberProperty(value); }

    _offsetX: number = 0;
    @Input()
    get offsetX() { return this._offsetX; }
    set offsetX(value: NumberInput) { this._offsetX = coerceNumberProperty(value); }

    _offsetY: number = 0;
    @Input()
    get offsetY() { return this._offsetY; }
    set offsetY(value: NumberInput) { this._offsetY = coerceNumberProperty(value); }

    isOpen: boolean = false;

    // public functions

    onClickOutside() {
        this.isOpen = false;
    }
}
